import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {compareNumber, DriverActivityEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useTtaMutation} from "../../../hooks/useTtaMutation";

export type DriverActivityTtaMenuProps = {
  context?: DriverActivityEntity[]
}

export const DriverActivityTtaMenu = (props: DriverActivityTtaMenuProps) => {
  const {context} = props

  const {t} = useTranslation(["translation", "common"]);

  const {
    associate,
    undoSplits,
    createPickupSplits,
    createDeliverySplits,
  } = useTtaMutation()

  const onAssociate = useCallback(() => {
    if (context) {
      if (context.length === 2) {
        const first = context[0]
        const last = context[1]

        if (first.pickupTransport && last.deliveryTransport) {
          associate(first.pickupTransport, last.deliveryTransport, undefined)
        } else if (first.deliveryTransport && last.pickupTransport) {
          associate(last.pickupTransport, first.deliveryTransport, undefined)
        }
      }
    }
  }, [context, associate])

  const showAssociate = useMemo(() => {
    if (context) {
      if (context.length === 2) {
        const first = context[0]
        const last = context[1]

        if (first.pickupTransport && last.deliveryTransport) {
          return true
        } else if (first.deliveryTransport && last.pickupTransport) {
          return true
        }
      }
    }

    return false
  }, [context])

  const showUndoSplit = useMemo(() => {
    if (context && context.length > 1) {
      const allTtaSplits = context.every(a => typeof a.tta !== 'undefined' && (a.tta.pickupMultipartRecord || a.tta?.deliveryMultipartRecord))
      if (allTtaSplits) {
        return true
      }
    }

    return false
  }, [context])

  const showCreatePickupSplits = useMemo(() => {
    if (context && context.length > 0) {
      const allTtas = context.every(a => typeof a.tta !== 'undefined')
      if (allTtas) {
        return true
      }
    }

    return false
  }, [context])

  const showCreateDeliverySplits = useMemo(() => {
    if (false) {
      if (context && context.length > 0) {
        const allTtas = context.every(a => typeof a.tta !== 'undefined')
        if (allTtas) {
          return true
        }
      }
    }

    return false
  }, [context])

  const showingSplitActions = useMemo(() => {
    return showUndoSplit || showCreatePickupSplits || showCreateDeliverySplits
  }, [showUndoSplit, showCreatePickupSplits, showCreateDeliverySplits])

  const onUndoSplit = useCallback(() => {
    if (context && showUndoSplit) {
      const ttas = context.map(a => a.tta!)
        .sort((a, b) => compareNumber(a.pickupTransport?.createDttm, b.pickupTransport?.createDttm))
      undoSplits(ttas, undefined)
    }
  }, [context, showUndoSplit, undoSplits])

  const onCreatePickupSplits = useCallback(() => {
    if (context && showCreatePickupSplits) {
      const ttas = context.map(a => a.tta!)
        .sort((a, b) => compareNumber(a.pickupTransport?.createDttm, b.pickupTransport?.createDttm))
      createPickupSplits(ttas, undefined)
    }
  }, [context, showCreatePickupSplits, createPickupSplits])

  const onCreateDeliverySplits = useCallback(() => {
    if (context && showCreateDeliverySplits) {
      const ttas = context.map(a => a.tta!)
        .sort((a, b) => compareNumber(a.pickupTransport?.createDttm, b.pickupTransport?.createDttm))
      createDeliverySplits(ttas, undefined)
    }
  }, [context, showCreateDeliverySplits, createDeliverySplits])

  return (
    <>
      {showingSplitActions &&
        <Menu.Divider />
      }
      {showAssociate &&
        <Menu.Item onClick={onAssociate}>
          {t("common.action.associate", "Associate", {ns: "common"})}
        </Menu.Item>
      }
      {showUndoSplit &&
        <Menu.Item onClick={onUndoSplit}>
          {t("common.action.undosplit", "Undo Split", {ns: "common"})}
        </Menu.Item>
      }
      {showCreatePickupSplits &&
        <Menu.Item onClick={onCreatePickupSplits}>
          {t("common.action.createpickupsplits", "Create Pickup Splits", {ns: "common"})}
        </Menu.Item>
      }
      {showCreateDeliverySplits &&
        <Menu.Item onClick={onCreateDeliverySplits}>
          {t("common.action.createdeliverysplits", "Create Delivery Splits", {ns: "common"})}
        </Menu.Item>
      }
    </>
  )
}
